













































import { Component, Vue, Watch, Prop} from 'vue-property-decorator';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import GiganautVue from '@/components/Shared/GiganautVue';
import JobWorkerDto from '@/models/JobWorkers/JobWorkerDto';
import JobWorkerStatus from '@/components/JobWorkers/Display/JobWorkerStatus.vue'
import JobWorkerStatusEnum from '@/models/JobWorkers/JobWorkerStatus';
import JobWorker from '@/components/JobWorkers/JobWorker.vue';

@Component({
  name: 'JobInterviewingWorkers',
  components: { JobWorkerStatus, JobWorker }
})
export default class extends GiganautVue {

	jobWorkerStatusEnum = JobWorkerStatusEnum;
	page = 1;
	perPage = 8;

	get selectedJobWorker() {
		return JobDetailsModule.jobWorkersVM.selectedInterviewingJobWorker;
	}

	set selectedJobWorker(value: JobWorkerDto) {
		JobDetailsModule.jobWorkersVM.selectedInterviewingJobWorker = value;
	}
	get currentJob() {
		return JobDetailsModule.currentJob;
	}
	
	get jobWorkers() {
		return JobDetailsModule.jobWorkersVM.jobWorkers;
	}

	get pagedJobWorkers() {
		return this.interviewingWorkers.slice((this.page - 1)* this.perPage, this.page* this.perPage)
	}

	get interviewingWorkers() {
		return this.jobWorkers.filter((jobWorker) => (
			jobWorker.status === JobWorkerStatusEnum.InterviewOne ||
			jobWorker.status === JobWorkerStatusEnum.InterviewTwo
		))
	}

	async onPageChanged(input: number){
		JobDetailsModule.jobWorkersVM.selectedInterviewingJobWorker = (this.pagedJobWorkers[0]);
	}

	get loadingWorkers() {
		return JobDetailsModule.loadingWorkers;
	}
}
